import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import LoadingSpinner from '../../common/LoadingSpinner'
import AITutorPricingProvider from '../../new-portal/ai-tutor-pricing/AITutorPricingProvider'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorPricingBody = dynamic(() => import('../../new-portal/ai-tutor-pricing/AITutorPricingPageWebView'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})
// some change
const AITutorPurchaseActivity: ActivityComponentType = () => {
  const { useAITutorFlow } = useAITutorStack()
  const { push, pop } = useAITutorFlow()
  return (
    <WebviewStackContainer height="52px" border={false} onBack={pop}>
      <div className="relative h-[calc(100vh-52px)] mt-16">
        <AITutorPricingProvider>
          <AITutorPricingBody />
        </AITutorPricingProvider>
      </div>
    </WebviewStackContainer>
  )
}

export default AITutorPurchaseActivity
